import React from 'react';
import WrappedBase from './WrappedBase';

import UnsubscribeAddressForm from '../containers/UnsubscribeAddressForm';

export default class UnsubscribeAddressFormWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <UnsubscribeAddressForm {...this.props} />
      </WrappedBase>
    );
  }
}
